export type Bonus = {
  number: number;
  title: string;
  description: string;
  includes: string[];
  value: number;
  image: string;
  accent: string;
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'The Obesity Assessment Worksheet',
    description: 'A structured worksheet for organizing the information relevant to an adult obesity assessment.',
    includes: [
      'Patient history organizer.',
      'Weight trajectory documentation fields.',
      'Relevant medical history checklist.',
      'Comorbidity review section.',
      'Outstanding information tracker.',
      'Clinical documentation template.',
    ],
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/gs3GZpMZWgE42LApuhUzV9/BONO_1_OBESITYBP-EN.png',
    accent: '#1D63D8',
  },
  {
    number: 2,
    title: 'The Metabolic & Comorbidity Review Matrix',
    description: 'A practical tool for organizing obesity-related health considerations.',
    includes: [
      'Metabolic health review worksheet.',
      'Comorbidity documentation matrix.',
      'Relevant laboratory results organizer.',
      'Cardiovascular risk information section.',
      'Additional assessment questions tracker.',
      'Reference verification checklist.',
    ],
    value: 19,
    image: 'https://cdn.magicpatterns.com/uploads/78Zm5mNFw7ET6uixyXR35B/BONO_2_OBESITYBP-EN.png',
    accent: '#15855A',
  },
  {
    number: 3,
    title: 'The Weight Management Consultation Planner',
    description: 'A practical worksheet for structuring patient-centered discussions about weight management.',
    includes: [
      'Patient goals and preferences worksheet.',
      'Treatment history organizer.',
      'Shared decision-making framework.',
      'Treatment discussion checklist.',
      'Questions requiring further review section.',
      'Consultation documentation template.',
    ],
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/jJMrXmfiwS3JvLyBewWKSo/BONO_3_OBESITYBP-EN.png',
    accent: '#D9620F',
  },
  {
    number: 4,
    title: 'The Obesity Treatment Review Tracker',
    description: 'A structured tool for organizing follow-up discussions and treatment reassessments.',
    includes: [
      'Treatment review worksheet.',
      'Patient-reported progress tracker.',
      'Treatment experience documentation fields.',
      'Tolerability and safety review checklist.',
      'Outstanding questions register.',
      'Next review planning sheet.',
    ],
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/jMtN987aHwFYBv9y7NeNyq/BONO_4_OBESITYBP-EN.png',
    accent: '#C8243A',
  },
  {
    number: 5,
    title: 'The Long-Term Obesity Care Checklist',
    description: 'A practical checklist for organizing periodic reviews and preparing future consultations.',
    includes: [
      'Periodic review checklist.',
      'Patient goals reassessment worksheet.',
      'Follow-up task organizer.',
      'Outstanding issues register.',
      'Reference verification section.',
      'Next consultation preparation template.',
    ],
    value: 15,
    image: 'https://cdn.magicpatterns.com/uploads/dDZD6dHi1e5Jxoo5jieTzg/BONO_5_OBESITYBP-EN.png',
    accent: '#15855A',
  },
];
